<template>
  <div>
    <div>
      <UserDetail :changeRoute="true" />
    </div>
  </div>
</template>

<script>
import UserDetail from './UserDetail.vue'
export default {
  components: {
    UserDetail,
  },
}
</script>
